import { BaseModel } from './base';

export class StaffTermination extends BaseModel {
  staffId: string;
  staffs: any[];
  terminatedDate: Date;
  terminatedLetter: string;
  copiedStaff: any[];
  subscriberId: string;
  siteId: string;
  createdbyId: string;
  createdbyName: string;
  modifiedBy: string;
  dateCreated: string;
  dateModified: string;
  memoNumber: string;
}
